<template>
    <main class="p-4 min-h-screen bg-gray-200"
        @keyup.enter="send">
        <div class="sm:w-1/2 lg:w-1/3 mx-auto md:mt-8">
            <div class="card">
                <h1 class="card-header flex items-center">
                    <router-link 
                        :to="{name: 'login'}" 
                        class="btn btn-blue py-0 px-1"
                    ><back-icon /></router-link>
                    <span class="ml-3">Reset Password</span>
                </h1>
                <div class="card-body">                
                    <div class="p-4 bg-green-200 rounded text-green-700 mb-6"
                        v-if="successMessage"
                        v-html="successMessage"></div>
                    <div class="form-group">
                        <app-input type="email"
                            v-model="form.email"
                            focus
                            placeholder="Email Address"
                            :error="form.errors.get('email')"
                            @updated="form.errors.clear('email')"></app-input>
                    </div>
                    <div>
                        <app-button @click="send"
                            :loading="loading"
                            class="btn-blue btn-block">Email Reset Instructions</app-button>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>
<script>
    import Form from '../helpers/Form'
    export default {
        components: {
            BackIcon: () => import('@/icons/ArrowBack.vue'),
        },
        data() {
            return {
                form: new Form({
                    email: ''
                }),
                loading: false,
                successMessage: null
            }
        },
        methods: {
            send() {
                this.loading = true
                this.form.errors.clear();
                this.$store.dispatch('auth/passwordRemind', this.form.payload())
                    .then(({ data }) => {
                        this.loading = false
                        this.successMessage = data.message
                        this.form.reset()
                    })
                    .catch(({ response }) => {
                        this.loading = false
                        this.form.errors.record(response.data)
                    })
            }
        }
    }
</script>